import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { isEmpty } from 'lodash'
import pluralize from 'pluralize'
import { IconPlayerPlay } from '@tabler/icons-react'

import { getCourses } from '@/reducers/baltoAcademy/baltoAcademy.actions'
import { Loader } from '@/components/loaders/Loader'
import { Pill } from '@/components/pills/Pill'
import { PageHeader } from '@/components/headers/PageHeader'

import { categorizeCourses } from './BaltoAcademy.helpers'

import './BaltoAcademyPage.scss'

const BaltoAcademyPage = () => {
  const dispatch = useDispatch()
  const { courses, loading } = useSelector((state) => state.baltoAcademy)
  const { parent_id: parentOrgId } = useSelector((state) => state.currentOrganization)

  const categorizedCourses = useMemo(
    () => categorizeCourses(courses, parentOrgId),
    [courses, parentOrgId]
  )

  useEffect(() => {
    dispatch(getCourses())
  }, [])

  return (
    <div className="balto-academy-page-container">
      <PageHeader title="Courses" />
      {loading && (
        <div data-testid="loading-spinner">
          <Loader centered />
        </div>
      )}
      {!isEmpty(courses) &&
        Object.entries(categorizedCourses).map(([category, categoryCourses]) => (
          <div
            key={category}
            className="course-category"
            data-testid={`course-category-${category}`}
          >
            <div className="category-heading">
              <h3>{category}</h3>
              <Pill
                small
                transparent
                content={`${categoryCourses.length} ${pluralize('course', categoryCourses.length)}`}
              />
            </div>
            <div className="category-divider" />
            <div className="course-grid">
              {categoryCourses.map((course) => (
                <Link
                  to={`/balto-academy/${course.id}?title=${course.title}`}
                  key={course.id}
                  data-testid={`course-link-${course.id}`}
                >
                  <div className="course-container" data-testid="course-container">
                    <div className="course-info">
                      {course.thumbnail ? (
                        <img
                          src={course.thumbnail}
                          alt={course.displayTitle}
                          data-testid="course-thumbnail"
                        />
                      ) : (
                        <div
                          className="thumbnail-placeholder"
                          data-testid="course-thumbnail-placeholder"
                        />
                      )}

                      <div>{course.displayTitle}</div>
                    </div>
                    <div className="play-icon balto-button brand circular">
                      <IconPlayerPlay />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
    </div>
  )
}

export default BaltoAcademyPage
